import OrderDataLayer from './OrderDataLayer';
import { CheckinOrder, FlightSegment } from '@websky/graphql';
import { DataLayerAnalytics } from '../DataLayerAnalytics';
import { OrderStep } from '../types';
import { OrderType } from './types';

class CheckinOrderDataLayer extends OrderDataLayer<CheckinOrder> {
	public constructor(instance: DataLayerAnalytics) {
		super(instance);
	}

	public getOrderType(): OrderType {
		return OrderType.Checkin;
	}

	public getFlightSegments(): FlightSegment[] {
		return this.getOrder().segments;
	}

	public getOrderStatus(): OrderStep {
		return OrderStep.Checkin;
	}
}

export default CheckinOrderDataLayer;
